/** Quote dates/HH:mm values are event wall time; startsAt/endsAt, when present,
 * are instants and must be projected through the event's zone for display. */
export function quoteShiftInEventZone<T extends Record<string, any>>(shift: T, eventZone?: string): T {
  if (!eventZone) return shift;
  const projected = { ...shift };
  for (const [instantField, dateField, timeField] of [['startsAt', 'startDate', 'startTime'], ['endsAt', 'endDate', 'endTime']]) {
    const instant = shift[instantField];
    if (!instant) continue;
    const date = new Date(instant);
    if (!Number.isFinite(date.getTime())) continue;
    try {
      const parts = new Intl.DateTimeFormat('en-US', { timeZone: eventZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(date);
      const part = (type: string) => parts.find(item => item.type === type)?.value;
      (projected as Record<string, any>)[dateField] = `${part('year')}-${part('month')}-${part('day')}`;
      (projected as Record<string, any>)[timeField] = `${part('hour')}:${part('minute')}`;
    } catch { /* Retain saved wall values if the event has an invalid zone. */ }
  }
  return projected;
}
